// Copyright (c) 2020 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import RgaDomainValues, {getDefaultState as getDefaultRgaDomainValues} from '../../shared/rga-domain-values/state/rga-domain-values';
import RgaSearchModel, {getDefaultState as getDefaultRgaSearchObject} from './rga-search-model';
import RgaSearchSelectedDomains, {getDefaultState as getDefaultSelectedDomains} from './selected-domains';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from './search-by-dropdown';
import t from 'tcomb';

const RgaSearchState = t.struct({
    busyCounter: BusyCounter,
    rgaDomainValues: RgaDomainValues,
    rgaSearchModel: RgaSearchModel,
    rgaSearchSelectedDomains: RgaSearchSelectedDomains,
    searchByDropDown: SearchByDropDown,
    searchQueryString: t.String
}, 'RgaSearchState');

export const getDefaultState = () => new RgaSearchState({
    busyCounter: getBusyCounterDefaultState(),
    rgaDomainValues: getDefaultRgaDomainValues(),
    rgaSearchModel: getDefaultRgaSearchObject(),
    rgaSearchSelectedDomains: getDefaultSelectedDomains(),
    searchByDropDown: getSearchByDropDownDefaultState(),
    searchQueryString: ''
});

export default RgaSearchState;



// WEBPACK FOOTER //
// ./src/rga/search/state/index.js